import { createFileRoute } from "@tanstack/react-router"
import { StoresList } from "@/features/stores/components"
import { storesListQuery } from "@/features/stores/core/hooks/useStoresList"
import { storesListSearchSchema } from "@/features/stores/core/types/filters"

export const Route = createFileRoute("/(authenticated)/settings/stores/")({
  validateSearch: storesListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData(storesListQuery(deps))
  },
  component: StoresList,
})
